import { render, staticRenderFns } from "./PersonalizationMicrosoftStep1.vue?vue&type=template&id=5b64ead6&scoped=true"
import script from "./PersonalizationMicrosoftStep1.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftStep1.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftStep1.vue?vue&type=style&index=0&id=5b64ead6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64ead6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b64ead6')) {
      api.createRecord('5b64ead6', component.options)
    } else {
      api.reload('5b64ead6', component.options)
    }
    module.hot.accept("./PersonalizationMicrosoftStep1.vue?vue&type=template&id=5b64ead6&scoped=true", function () {
      api.rerender('5b64ead6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/microsoft/PersonalizationMicrosoftStep1.vue"
export default component.exports